module.exports = __webpack_public_path__ + "static/media/layer-group.b037f6f2.svg";